<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-green" sprite="message" />
          Port Out Requests
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-green" sprite="message" />
            Port Out Requests
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <order-detail
      :orderDetailVisible="orderDetailVisible"
      :selectedOrder="selectedOrder"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { ExportToCsv } from "export-to-csv";
import moment from 'moment-timezone';

import feathersClient from "../../../feathers/feathers-client";
import orderDetail from "./components/orderDetail";

export default {
  name: "PortOutRequestsTable",

  data() {
    return {
      search: "",
      tableLoading: false,
      visibleActionsId: "",
      total: 0,
      tableData: [],
      allPortOutRequests: [],
      selectedOrder: null,
      orderDetailVisible: false,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: () => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-green" sprite="message" />
                </div>
              ];
            }
          }
        },
        {
          field: "orderId",
          title: "Order Id",
          sortable: true,
          minWidth: 150
        },
        {
          field: "tenantName",
          title: "Tenant Name",
          sortable: true,
          minWidth: 150
        },
        {
          field: "date",
          title: "Date",
          sortable: true,
          minWidth: 100,
          slots: {
            default: ({row}) => {
              return [
                <span>{moment(row.date).format('YYYY-MM-DD')}</span>
              ]
            }
          }
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-tooltip content="View Order Details" placement="top">
                    <el-button
                      id={"edit-" + row.id}
                      icon="el-icon-view"
                      onClick={() => this.viewOrderDetails(row)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  components: {
    orderDetail
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {

    user() {
      this.findPortOutRequests();
    },

    search: debounce(function() {
      this.searchPortOutRequests();
    }, 500)
  },

  methods: {
    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map(item => ({
          orderId: item.orderId,
          tenantName: item.tenantName,
          date: item.date
        }));

        const options = {
          filename: "port_out_requests",
          showLabels: true,
          headers: ["Order ID", "Tenant Name", "Date"]
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchPortOutRequests() {
      if (this.search.length) {
        this.tableData = this.tableData.filter(data =>
          data.tenantName.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allPortOutRequests];
      }
      this.total = this.tableData.length;
    },

    // ⭐️ Table Operations ⭐️ //
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.viewOrderDetails(data.row);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    viewOrderDetails(row) {
      this.tableLoading = true;
      const {id, tenantName} = row;
      feathersClient
        .service("port-out-orders")
        .get(id)
        .then(res => {
          res.tenantId = tenantName;
          this.selectedOrder = res;
          this.tableLoading = false;
          this.orderDetailVisible = true;
        });
    },

    closeDialog() {
      this.orderDetailVisible = false;
    },

    findPortOutRequests() {
      this.tableLoading = true;

      let query = {};

      const {userRole, partnerId} = this.user;

      if(+userRole === 11){
        query = {partnerId}
      }

      feathersClient
        .service("port-out-orders")
        .find({
          paginate: false,
          query
        })
        .then(res => {
          this.tableData = [...res];
          this.allPortOutRequests = [...res];
          this.total = res.length;
          this.tableLoading = false;
        });
    }
  },

  mounted() {
    if (this.user) {
      this.findPortOutRequests();
    }
  }
};
</script>
